// Use direct property access for Vite compatibility
// Vite's define option replaces `process.env.KEY` literals at build time,
// but does not support destructuring from process.env
const SERVICES = {
  // V1 SERVICES
  AUTH: process.env.REACT_APP_AUTH_SERVICE_URL,
  ASSET: process.env.REACT_APP_ASSET_SERVICE_URL,
  USER: process.env.REACT_APP_USER_SERVICE_URL,
  SUBSCRIPTION: process.env.REACT_APP_SUBSCRIPTION_SERVICE_URL,
  ORDER: process.env.REACT_APP_ORDER_SERVICE_URL,
  RENDER: process.env.REACT_APP_RENDER_SERVICE_URL,
  MEDIA: process.env.REACT_APP_MEDIA_SERVICE_URL,
  FONTS: process.env.REACT_APP_FONT_HOST_URL,
  // V2 SERVICES
  ASSET_V2: process.env.REACT_APP_ASSET_SERVICE_URL_V2,
  USER_V2: process.env.REACT_APP_USER_SERVICE_URL_V2,
  ORDER_V2: process.env.REACT_APP_ORDER_SERVICE_URL_V2,
  RENDER_V2: process.env.REACT_APP_RENDER_SERVICE_URL_V2
};

export default SERVICES;
